import { toast } from 'vue3-toastify';
import ErrorInfo from 'src/components/icons/error-message-icon'
import closeIcon from 'src/components/icons/error-message-close'
import TickIcon from 'src/components/icons/tick-icon'
import WarningIconTriangle from 'src/components/icons/warning-icon-triangle/'
import { h } from 'vue';

const Toaster = {
    notifyError: (error, timer) => {
        if (window.innerWidth <= 900) {
            toastError(error, true, timer)
        }
        else {
            toastError(error, false, timer)
        }

    },
    notifySuccess: (message) => {
        if (window.innerWidth <= 900) {
            toastSuccess(message, true)
        }
        else {
            toastSuccess(message, false)
        }
    },
    notifyWarn: (message) => {
        if (window.innerWidth <= 900) {
            toastWarn(message, true)
        }
        else {
            toastWarn(message, false)
        }
    },
    notifyMalwareWarning: (message) => {
        if (window.innerWidth <= 900) {
            toastMalwareWarning(message, true)
        }
        else {
            toastMalwareWarning(message, false)
        }
    }
}

const toastError = (error, isTab = false, timer = 4000) => {
    toast.error(error, {
        hideProgressBar: true,
        icon: ErrorInfo,
        transition: 'slide',
        closeButton: closeIcon,
        position: isTab ? toast.POSITION.TOP_CENTER : toast.POSITION.BOTTOM_LEFT,
        clearOnUrlChange: false,
        autoClose: timer,
        toastStyle: {
            backgroundColor: '#DC0024',
        },
    });
}
const toastSuccess = (message, isTab = false) => {
    toast.success(message, {
        hideProgressBar: true,
        icon: TickIcon,
        transition: 'slide',
        closeButton: closeIcon,
        position: isTab ? toast.POSITION.TOP_CENTER : toast.POSITION.BOTTOM_LEFT,
        clearOnUrlChange: false,
        toastStyle: {
            backgroundColor: '#26A568'
        },
    });
}
const toastWarn = (message, isTab = false) => {
    toast.success(message, {
        hideProgressBar: true,
        icon: ErrorInfo,
        transition: 'slide',
        closeButton: closeIcon,
        closeOnClick: true,
        position: isTab ? toast.POSITION.TOP_CENTER : toast.POSITION.BOTTOM_LEFT,
        clearOnUrlChange: false,
        autoClose: false,
        toastStyle: {
            backgroundColor: '#FFC929',
            color: '#000000'
        },
    });
}

const toastMalwareWarning = (message, isTab = false) => {
    toast(message, {
        hideProgressBar: true,
        icon: WarningIconTriangle,
        transition: 'slide',
        closeButton: () => h(closeIcon, { fillColor: '#1E242C' }),
        position: isTab ? toast.POSITION.TOP_CENTER : toast.POSITION.BOTTOM_LEFT,
        clearOnUrlChange: false,
        containerClassName: 'taost-container-class toast-malware-container',
        toastClassName: 'taost-wrapper-class toast-malware-warning',
        toastStyle: {
            backgroundColor: '#FCFCFD',
            color: '#1E242C'
        },
    });
}
export { Toaster };